// extracted by mini-css-extract-plugin
export default {"group":"Select_group__8la9S","label":"Select_label__GDqD9","required":"Select_required__-R2h1","selectWrapper":"Select_selectWrapper__LL+k7","select":"Select_select__tUYup"};